module.exports = __webpack_public_path__ + "static/media/in-vector.58d251a4.jpg";